import { render, staticRenderFns } from "./SettingsCustomer.vue?vue&type=template&id=2489c22a&"
import script from "./SettingsCustomer.vue?vue&type=script&lang=ts&"
export * from "./SettingsCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports